export default {
  primaryColor: '#F67F00',
  linearBarColor: '#F67F00',
  linearBg: '#FFF4E0',
  logo: '/images/clientB_logo.png',
  showBottomLogo: false,
};
